/* My First Football Shirt personalisation configurator (external asset, Liquid-free) */
(function () {
  function initConfigurator(root) {
    if (!root || root.dataset.cfgInit === '1') return;
    root.dataset.cfgInit = '1';

    /* Format + Size -> variant id (explicit, authoritative mapping) */
    var MAP = {
      'Artwork|A4': '59888929669454',
      'Print|A4': '59888929702222', 'Print|A3': '59888929734990', 'Print|A2': '59888929767758',
      'Framed|A4': '59888929800526', 'Framed|A3': '59888929833294', 'Framed|A2': '59888929866062'
    };
    var FALLBACK = {
      '59888929669454': '£9.99', '59888929702222': '£14.99', '59888929734990': '£18.99',
      '59888929767758': '£24.99', '59888929800526': '£29.99', '59888929833294': '£39.99', '59888929866062': '£54.99'
    };
    var VARIANTS = {};
    try {
      var dataEl = root.querySelector('.mffs-cfg__data');
      VARIANTS = (JSON.parse(dataEl.textContent) || {}).variants || {};
    } catch (e) {}

    var $ = function (sel) { return root.querySelector(sel); };
    var form = $('.mffs-cfg__form');
    var elFormat = $('[data-cfg-format]'), elSize = $('[data-cfg-size]');
    var elVariant = $('[data-cfg-variant-id]');
    var elPrice = $('[data-cfg-price]'), elPriceNote = $('[data-cfg-pricenote]');
    var elArtworkHint = $('[data-cfg-artwork-hint]');
    var elErrPrint = $('[data-cfg-error-print]');
    var elSubmit = $('[data-cfg-submit]'), elBtnLabel = $('[data-cfg-btn-label]'), elSpinner = $('[data-cfg-spinner]');
    var elErrForm = $('[data-cfg-error-form]');
    var sizeOptions = Array.prototype.slice.call(elSize.querySelectorAll('option[data-size]'));

    function priceText(id) { return (VARIANTS[id] && VARIANTS[id].priceText) || FALLBACK[id] || ''; }

    function currentVariantId() {
      var f = elFormat.value, s = elSize.value;
      if (f === 'Artwork') s = 'A4';
      if (!f || !s) return '';
      return MAP[f + '|' + s] || '';
    }

    function applyArtworkRules() {
      var isArtwork = elFormat.value === 'Artwork';
      sizeOptions.forEach(function (opt) {
        if (opt.dataset.size === 'A4') return;
        opt.disabled = isArtwork;
        opt.hidden = isArtwork;
      });
      if (isArtwork) { elSize.value = 'A4'; elArtworkHint.hidden = false; }
      else { elArtworkHint.hidden = true; }
    }

    function updatePrice() {
      var id = currentVariantId();
      elVariant.value = id;
      if (id) {
        elPrice.textContent = priceText(id) || '';
        elPriceNote.textContent = elFormat.value + ' · ' + (elFormat.value === 'Artwork' ? 'A4' : elSize.value);
      } else {
        elPrice.textContent = 'from £9.99';
        elPriceNote.textContent = 'Choose a format & size';
      }
      refreshSubmitState();
    }

    function printChosen() { return !!currentVariantId(); }

    function refreshSubmitState() {
      var ok = printChosen();
      elSubmit.disabled = !ok;
      if (ok) elErrPrint.hidden = true;
    }

    function choice() { var c = root.querySelector('[data-cfg-choice]:checked'); return c ? c.value : 'upload'; }
    function applyChoice() {
      var c = choice();
      $('[data-cfg-panel="upload"]').hidden = (c !== 'upload');
      $('[data-cfg-panel="colours"]').hidden = (c !== 'colours');
    }
    root.querySelectorAll('[data-cfg-choice]').forEach(function (r) { r.addEventListener('change', applyChoice); });

    function bindColour(inputSel, hexSel) {
      var inp = $(inputSel), hex = $(hexSel);
      if (!inp || !hex) return;
      inp.addEventListener('input', function () { hex.textContent = inp.value.toUpperCase(); });
    }
    bindColour('[data-cfg-shirtcolour]', '[data-cfg-shirtcolour-hex]');
    bindColour('[data-cfg-textcolour]', '[data-cfg-textcolour-hex]');

    var photo = $('[data-cfg-photo]'), fileNameEl = $('[data-cfg-filename]');
    photo.addEventListener('change', function () {
      if (photo.files && photo.files[0]) {
        fileNameEl.textContent = '✓ ' + photo.files[0].name;
        fileNameEl.hidden = false;
        $('[data-cfg-error-photo]').hidden = true;
      } else { fileNameEl.hidden = true; }
    });

    elFormat.addEventListener('change', function () { applyArtworkRules(); updatePrice(); });
    elSize.addEventListener('change', updatePrice);

    root.querySelectorAll('[data-cfg-required]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        inp.classList.remove('mffs-cfg__input--invalid');
        var err = root.querySelector('[data-cfg-error="' + inp.dataset.cfgRequired + '"]');
        if (err) err.hidden = true;
      });
    });

    function validate() {
      var ok = true, firstBad = null;
      if (!printChosen()) { elErrPrint.hidden = false; ok = false; }
      root.querySelectorAll('[data-cfg-required]').forEach(function (inp) {
        var err = root.querySelector('[data-cfg-error="' + inp.dataset.cfgRequired + '"]');
        if (!inp.value.trim()) {
          inp.classList.add('mffs-cfg__input--invalid');
          if (err) err.hidden = false;
          ok = false; if (!firstBad) firstBad = inp;
        }
      });
      if (choice() === 'upload') {
        if (!(photo.files && photo.files[0])) {
          $('[data-cfg-error-photo]').hidden = false;
          ok = false; if (!firstBad) firstBad = photo;
        } else {
          var t = photo.files[0].type;
          if (t && t !== 'image/jpeg' && t !== 'image/png') {
            $('[data-cfg-error-photo]').hidden = false;
            ok = false; if (!firstBad) firstBad = photo;
          }
        }
      }
      if (firstBad && firstBad.focus) firstBad.focus();
      return ok;
    }

    function syncProperties() {
      var propChoice = $('[data-cfg-prop-choice]');
      var propShow = $('[data-cfg-prop-showphoto]');
      var propShirt = $('[data-cfg-prop-shirtcolour]');
      var propText = $('[data-cfg-prop-textcolour]');
      var c = choice();
      if (c === 'upload') {
        propChoice.value = 'Uploaded photo';
        propShow.disabled = false;
        propShow.value = $('[data-cfg-showphoto]').checked ? 'Yes' : 'No';
        propShirt.disabled = true; propText.disabled = true;
      } else {
        propChoice.value = 'Picked colours';
        propShow.disabled = true;
        propShirt.disabled = false; propShirt.value = $('[data-cfg-shirtcolour]').value.toUpperCase();
        propText.disabled = false; propText.value = $('[data-cfg-textcolour]').value.toUpperCase();
        try { photo.value = ''; } catch (e) {}
      }
    }

    function setBusy(b) {
      elSubmit.setAttribute('aria-busy', b ? 'true' : 'false');
      elSpinner.hidden = !b;
      elBtnLabel.textContent = b ? 'Creating…' : 'Create your print';
      elSubmit.disabled = b ? true : !printChosen();
    }

    var ROOT_PATH = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    var ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) ? Theme.routes.cart_add_url : (ROOT_PATH + 'cart/add.js');
    var CART_URL = ROOT_PATH + 'cart.js';
    var CART_PAGE = ROOT_PATH + 'cart';

    function cartSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) {
        if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
      });
      return ids;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      elErrForm.hidden = true;
      if (!validate()) return;
      syncProperties();

      var fd = new FormData(form);
      fd.delete('cfg_colour_choice');
      if (choice() !== 'upload') fd.delete('properties[Photo]');
      var ids = cartSectionIds();
      if (ids.length) fd.set('sections', ids.join(','));

      setBusy(true);
      fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
        .then(function (res) {
          if (!res.ok || res.body.status) {
            var msg = (res.body && (res.body.description || res.body.message)) || 'Sorry, we could not add this to your bag. Please try again.';
            elErrForm.textContent = msg; elErrForm.hidden = false;
            setBusy(false);
            return;
          }
          var added = res.body;
          return fetch(CART_URL).then(function (r) { return r.json(); }).then(function (cart) {
            try {
              var evt = new Event('cart:update', { bubbles: true });
              evt.detail = {
                resource: cart,
                sourceId: root.id,
                data: {
                  source: 'mffs-configurator',
                  productId: root.dataset.productId,
                  itemCount: cart.item_count,
                  variantId: String(elVariant.value),
                  sections: added.sections
                }
              };
              document.dispatchEvent(evt);
            } catch (err) {}
            setBusy(false);
            if (!document.querySelector('cart-drawer-component')) window.location.href = CART_PAGE;
          });
        })
        .catch(function () { window.location.href = CART_PAGE; });
    });

    applyChoice();
    applyArtworkRules();
    updatePrice();
  }

  function boot() {
    document.querySelectorAll('personalisation-configurator').forEach(initConfigurator);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
